module.exports = __webpack_public_path__ + "img/tick-dark-blue.7e239298.svg";